import Icon from 'veui/components/Icon'

Icon.register({
  'arrow-right': {
    paths: [
      {
        d: 'M28.21 5.34l17.25 17.25a2 2 0 01.12 2.7l-.12.12-17.25 17.25a2 2 0 01-2.94-2.7l.12-.12 13.88-13.89H4.05a2 2 0 01-2-1.85v-.15a2 2 0 011.85-2h35.27L25.4 8.16a2 2 0 01-.12-2.7l.12-.12a2 2 0 012.7-.12l.12.12 17.25 17.25L28.21 5.34z'
      }
    ],
    width: '48',
    height: '48'
  }
})
